export const DEFAULT_HITS_PER_PAGE = 10;

export const DEFAULT_FILTER_OPTIONS_LIMIT = 5;

export const GENERIC_ALL_TAB_CATEGORY_LABEL = 'ALL';
